import React, { useState, useMemo } from "react";
import { sites, employees } from "../data/sampleData";
import OpsDashboard from "./OpsDashboard";
import "./Sites.css";

export default function Sites() {
  const today = new Date().toISOString().slice(0, 7);

  /* 🔹 GLOBAL FILTERS (PERSISTENT) */
  const [filters, setFilters] = useState({
    siteIds: [],
    startMonth: today,
    endMonth: today
  });

  const [query, setQuery] = useState("");
  const [selectedSite, setSelectedSite] = useState(null);
  const [view, setView] = useState("SITES"); // SITES | OPS | GLOBAL

  /* 🔹 SITE SEARCH + FILTER */
  const visibleSites = useMemo(() => {
    return sites.filter(s => {
      const q = query.toLowerCase();
      const matchesQuery =
        s.name.toLowerCase().includes(q) ||
        s.region?.toLowerCase().includes(q);

      const matchesSiteFilter =
        filters.siteIds.length === 0 ||
        filters.siteIds.includes(s.siteId);

      return matchesQuery && matchesSiteFilter;
    });
  }, [query, filters]);

  /* 🔹 GLOBAL FATIGUE */
  if (view === "GLOBAL") {
    return (
      <OpsDashboard
        global
        filters={filters}
        onBack={() => setView("SITES")}
      />
    );
  }

  /* 🔹 SITE OPS */
  if (view === "OPS" && selectedSite) {
    return (
      <OpsDashboard
        site={selectedSite}
        filters={filters}
        onBack={() => {
          setSelectedSite(null);
          setView("SITES");
        }}
      />
    );
  }

  return (
    <div className="page">
      {/* ================= STICKY FILTER BAR ================= */}
      <div className="filters-bar">
        <input
          className="search"
          placeholder="Search sites..."
          value={query}
          onChange={e => setQuery(e.target.value)}
        />

        <select
          multiple
          value={filters.siteIds}
          onChange={e =>
            setFilters({
              ...filters,
              siteIds: [...e.target.selectedOptions].map(o => o.value)
            })
          }
        >
          {sites.map(s => (
            <option key={s.siteId} value={s.siteId}>
              {s.name}
            </option>
          ))}
        </select>
        

        <input
          type="month"
          value={filters.startMonth}
          onChange={e =>
            setFilters({ ...filters, startMonth: e.target.value })
          }
        />

        <input
          type="month"
          value={filters.endMonth}
          onChange={e =>
            setFilters({ ...filters, endMonth: e.target.value })
          }
        />
        
        
        <button
          className="btn global"
          onClick={() => setView("GLOBAL")}
        >
          🌍 Global Fatigue <span className="badge">●</span>
        </button>
      </div>

      {/* ================= SITES GRID ================= */}
      <div className="grid">
        {visibleSites.map(site => {
          const empCount = employees.filter(
            e => e.homeSiteId === site.siteId
          ).length;

          return (
            <div key={site.siteId} className="card site-card">
              <h3>{site.name}</h3>
              <p>{site.locality}</p>
              <p><strong>Area Manager -: </strong>{site.manager_name}</p>

              <div className="meta">👥 {empCount} staff</div>

              <button
                className="btn primary"
                onClick={() => {
                  setSelectedSite(site);
                  setView("OPS");
                }}
              >
                📊 Ops / Roster
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
